



































































































































































































































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import PageLayout from '@/components/page/PageLayout.vue'
import listMixins from '@/mixins/list'
import PartnerApi from '@/api/partner'
import AreaApi from '@/api/area'
import { TOKEN } from '@/store/mutation-types'

@Component({
	name: 'partnerFirstAuditList',
	components: {
		PageLayout,
	},
})
export default class UsersList extends Mixins(listMixins) {
	private visible: boolean = false
	private modVisible: boolean = false

	private addForm: any = {}
	private modForm: any = {}
	private companyOptions: any = []
	private headers: any = {
		[TOKEN]: this.$ls.get(TOKEN),
	}
	private uploading: boolean = false
	// 表头，测试soruceTree，rebase合并到testMerge
	private columns: any = [
		{
			title: '序号',
			dataIndex: 'order',
			align: 'center',
			width: 60,
			scopedSlots: { customRender: 'order' },
		},
		{
			title: '状态',
			dataIndex: 'status',
			scopedSlots: { customRender: 'status' },
		},
		{
			title: '开启时间',
			dataIndex: 'rangeTime',
			scopedSlots: { customRender: 'rangeTime' },
		},
		{
			title: '开启时间段',
			dataIndex: 'workTime',
			scopedSlots: { customRender: 'workTime' },
		},
		{
			title: '开启类型',
			dataIndex: 'checkType',
			scopedSlots: { customRender: 'checkType' },
		},
		{
			title: '具体条件',
			dataIndex: 'content',
			width: 200,
		},
		{
			title: '审核角色',
			dataIndex: 'roleTypeName',
			scopedSlots: { customRender: 'roleTypeName' },
		},
		{
			title: '审核人员',
			dataIndex: 'checkorsList',
			scopedSlots: { customRender: 'checkorsList' },
		},
		{
			title: '创建时间',
			dataIndex: 'createTime',
			scopedSlots: { customRender: 'createTime' },
		},
		{
			title: '修改时间',
			dataIndex: 'updateTime',
			scopedSlots: { customRender: 'updateTime' },
		},
		{
			title: '创建人',
			dataIndex: 'creatorName',
		},
		{
			title: '修改人',
			dataIndex: 'updatorName',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: { customRender: 'action' },
		},
	]

	private data: any[] = []
	private first: boolean = true
	private province: any[] = []
	private city: any[] = []
	private area: any[] = []
	private timer: any = ''

	private addLoading: boolean = false
	private modLoading: boolean = false

	public created() {
		this.addForm = this.$form.createForm(this)
		this.modForm = this.$form.createForm(this)
		this.getProvice()
	}

	public activated() {
		this.getList()
	}

	public getList() {
		const form = this.getSearchValues()
		if (form.companyId) {
			form.companyId = form.companyId['value']
		}
		return PartnerApi.getCheckList(form).then((data: any) => {
			this.data = data.data.retList
			this.data &&
				this.data.forEach(item => {
					let list: any = []
					item.checkors &&
						item.checkors.forEach((items: any) => {
							list.push(items.checkorName)
							this.$set(item, 'checkorsList', list.join(','))
						})
				})
			this.total = data.data.count
			this.resetSelected()
		})
	}

	private doMod() {
		const selected: any = this.selected[0]
		const copy = {
			id: selected.id,
			partnerId: selected.partnerId,
			checked: selected.checked,
		}
		const area = this.modForm.getFieldsValue([
			'provinceCode',
			'cityCode',
			'areaCode',
		])
		const params = Object.assign({}, area, copy)
		this.modLoading = true
		PartnerApi.setAuditRule(params)
			.then((res: any) => {
				this.$message.success('更新成功')
				this.modVisible = false
				this.getList()
			})
			.finally(() => {
				this.modLoading = false
			})
	}

	private doAdd() {
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.addLoading = true
				values = cloneDeep(values)
				values.checked = '1'
				PartnerApi.setAuditRule(values)
					.then((res: any) => {
						this.$message.success('新增设置成功')
						this.visible = false
						this.resetPage()
						this.getList()
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}

	private isEnable(e: any, action: any) {
		const values = {
			id: action.id,
			partnerId: action.partnerId,
			provinceCode: action.provinceCode,
			cityCode: action.cityCode,
			areaCode: action.areaCode,
			checked: e ? '1' : '0',
		}
		PartnerApi.setAuditRule(values).then((res: any) => {
			this.$message.success('修改成功')
			this.visible = false
			this.resetPage()
			this.getList()
		})
	}

	private modifyInfo() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.modVisible = true
			this.getProvice()
			this.handleProvinceChange(selected.provinceCode)
			this.handleCityChange(selected.cityCode)
			this.$nextTick(() => {
				this.modForm.setFieldsValue({
					companyName: selected.companyName,
					provinceCode: selected.provinceCode,
					cityCode: selected.cityCode,
					areaCode: selected.areaCode,
				})
			})
		}
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择公司')
			return false
		}
		return true
	}

	private getProvice() {
		AreaApi.getProvince().then((res: any) => {
			this.province = res.data
		})
	}

	private handleProvinceChange(e: any) {
		this.modForm.resetFields(['provinceCode', 'cityCode', 'areaCode'])
		AreaApi.getCity(e).then((res: any) => {
			this.city = res.data
		})
	}

	private handleCityChange(e: any) {
		this.modForm.resetFields(['cityCode', 'areaCode'])
		AreaApi.getArea(e).then((res: any) => {
			this.area = res.data
		})
	}
}
